import { Button } from 'antd'
import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

interface TabButtonProps {
  active: boolean
  onClick: () => void
  content: { text: string; count: number } | ReactNode
}

const TabButton: FunctionComponent<TabButtonProps> = ({
  active,
  onClick,
  content,
}) => {
  return (
    <StyledTabButton $active={active} onClick={onClick}>
      {content && typeof content === 'object' && 'text' in content ? (
        <span>
          {content.text} ({content.count})
        </span>
      ) : (
        content
      )}
    </StyledTabButton>
  )
}

export default TabButton

const StyledTabButton = styled(Button)<{ $active: boolean }>`
  padding: 8px 16px;

  color: ${({ $active, theme }): string =>
    $active ? theme.colors.brand.secondary : theme.colors.text.secondary};

  border-radius: 30px;
  box-shadow: none;
  border: ${({ $active, theme }): string =>
    $active
      ? `${theme.colors.brand.secondary} 1px solid`
      : 'transparent'} !important;

  &:hover {
    border-color: ${({ $active, theme }): string =>
      $active
        ? `${theme.colors.brand.secondaryHover} 1px solid`
        : 'transparent'};
    color: ${({ $active, theme }): string =>
      $active
        ? theme.colors.brand.secondary
        : theme.colors.brand.secondaryHover} !important;
  }
`
